import createSvgIcon from "./utils/create_icon"

const CloseSmall = createSvgIcon(<path d="M15.707 9.707a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12z" fill="currentColor" />, "CloseSmall")
export default CloseSmall
